/* global jQuery COMPONENTS */

COMPONENTS.ComponentSlider = (function ($) {
  function ComponentSlider () {
    this.$component = $('[data-ecs-component="component-slider"]')
    this.$sliderElem = this.$component.find('[data-ecs-components-control="slider"]')
    this.$sliderControls = this.$component.find('[data-ecs-slider-control]')

    this.utility = new COMPONENTS.Utility()
    this.clicked = false
    this.targetNav = 1
  }

  ComponentSlider.prototype.init = function () {
    const component = this

    component.utility.initSliderCounters()

    $(window).on('resize orientationchange', function () {
      component.utility.initSliderCounters()
    })

    component.updateNavigation = function (slideIndex) {
      $(component.$sliderControls).each(function () {
        $(this).removeClass('ecs_active')
      })

      $(component.$sliderControls).filter('[data-ecs-slide-button="' + slideIndex + '"]').addClass('ecs_active')
    }

    $(component.$sliderElem).each(function () {
      let transitionCount = 0;
      const slidesToDisplay = ($(this).data('ecs-components-slide-count') ? $(this).data('ecs-components-slide-count') : 1)
      const sliderLinkAttr = $(this).data('ecs-components-slider-link')
      var sliderLink = null
      if (typeof sliderLinkAttr !== 'undefined' && sliderLinkAttr !== false) {
        sliderLink = '[data-ecs-components-slider="' + $(this).data('ecs-components-slider-link') + '"]'
      }
      var sliderFade = false
      const sliderFadeAttr = $(this).attr('data-ecs-components-slider-fade')
      if (typeof sliderFadeAttr !== 'undefined' && sliderFadeAttr !== false) {
        sliderFade = true
      }
      var sliderAutoplay = true
      const sliderAutoplayAttr = $(this).attr('data-ecs-components-slider-autoplay')
      if (typeof sliderAutoplayAttr !== 'undefined') {
        sliderAutoplay = sliderAutoplayAttr
      }
      var sliderDotTitles = false
      const sliderDotTitleAttr = $(this).attr('data-ecs-components-slider-dottitles')
      if (typeof sliderDotTitleAttr !== 'undefined' && sliderDotTitleAttr !== false) {
        sliderDotTitles = true
      }

      // Check if the center alignment is true
      var sliderCenterMode = false
      const sliderCenterModeAttr = $(this).attr('data-ecs-components-slider-center-mode')
      if (typeof sliderCenterModeAttr !== 'undefined' && sliderCenterModeAttr !== false) {
        sliderCenterMode = true
      }

      // Check if the center padding variable is being used
      let sliderCenterPadding = '0px'
      const sliderCenterPaddingAttr = $(this).attr('data-ecs-components-slider-center-padding')
      if (typeof sliderCenterPaddingAttr !== 'undefined' && sliderCenterPaddingAttr !== false) {
        sliderCenterPadding = sliderCenterPaddingAttr
      }

      const sliderAdaptive = ($(this).data('ecs-components-slider-adaptive') ? $(this).data('ecs-components-slider-adaptive') : false)

      const sliderVars = component.utility.getSliderVars(slidesToDisplay, sliderLink, sliderFade, sliderAdaptive, sliderAutoplay, sliderDotTitles, sliderCenterMode, sliderCenterPadding)

      $(this).slick(sliderVars)
      component.utility.bindSliderAriaSelected($(this))

      // if ($('body').hasClass('ecs_aos_enabled')) {
      //   $(document).ready(function () {
      //     AOS.init()
      //   })
      // }

      // If Story Slider
      if ((sliderLink != null) && (sliderLink.includes('story-content'))) {
        // Before slide change
        $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          if (component.clicked === true) {
            // Use targeted slide number to change to appropriate slide index
            component.clicked = false
            component.updateNavigation(component.targetNav)
          } else {
            // Use nextSlide + 1 because slide index needs increased by 1
            component.updateNavigation(parseInt(nextSlide) + 1)
          }
        })
      }

      // After slide change
      $(this).on('beforeChange', function () {
        transitionCount++
        $(this).attr('data-ecs-transition-count', transitionCount)

        // Counter is EVEN
        if (transitionCount % 2 === 0) {
          $(this).addClass('ecs_counter_even')
          $(this).removeClass('ecs_counter_odd')
        }

        // Counter is ODD
        if ((transitionCount + 1) % 2 === 0) {
          $(this).removeClass('ecs_counter_even')
          $(this).addClass('ecs_counter_odd')
        }

        if (transitionCount % 3 === 0) {
          $(this).addClass('ecs_counter_divisible_3')
          $(this).removeClass('ecs_counter_divisible_4')
          $(this).removeClass('ecs_counter_divisible_5')
        }

        if (transitionCount % 4 === 0) {
          $(this).removeClass('ecs_counter_divisible_3')
          $(this).addClass('ecs_counter_divisible_4')
          $(this).removeClass('ecs_counter_divisible_5')
        }

        if (transitionCount % 5 === 0) {
          $(this).removeClass('ecs_counter_divisible_3')
          $(this).removeClass('ecs_counter_divisible_4')
          $(this).addClass('ecs_counter_divisible_5')
        }
      })
    })

    $(component.$sliderControls).each(function () {
      const sliderSearch = $(this).attr('data-ecs-slider-control')
      const $targetSlider = $(component.$sliderElem).filter('[data-ecs-components-slider-link="' + sliderSearch + '"]')
      const targetSlide = parseInt($(this).attr('data-ecs-slide-button'))

      // Add on-click event to activate the navigation-selected slide
      $(this).children('[data-ecs-slider-button]').click(function () {
        component.clicked = true
        component.targetNav = targetSlide
        $targetSlider.slick('slickGoTo', (targetSlide - 1))
      })
    })
  }

  return ComponentSlider
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.componentSlider = new COMPONENTS.ComponentSlider()
  COMPONENTS.componentSlider.init()
})
